import { FC } from 'react'
import { ModalSimple } from 'components/ModalSimple'

import { ModalIdentificationDocumentsProps } from './types'

import s from './ModalIdentificationDocuments.module.less'

export const ModalIdentificationDocuments: FC<ModalIdentificationDocumentsProps> = (props) => {
  const { id, handleCloseModalIdentificationDocuments } = props

  return (
    <ModalSimple
      id={id}
      onClose={handleCloseModalIdentificationDocuments}
      size="nm"
      title="Документы, удостоверяющие личность"
    >
      <div className={s.detailBody}>
        <div>
          <ul className={s.list}>
            <li>Паспорт гражданина РФ</li>
            <li>Временное удостоверение личности с фотографией владельца</li>
            <li>Водительское удостоверение</li>
            <li>Паспорт иностранного гражданина</li>
            <li>Заграничный паспорт</li>
            <li>Военный билет, если гражданин находится на действительной службе</li>
            <li>Паспорт моряка</li>
            <li>Удостоверение личности офицера</li>
            <li>Вид на жительство</li>
            <li>Удостоверение беженца</li>
          </ul>
        </div>
      </div>
    </ModalSimple>
  )
}
